$('.menu .link').bind('click', function (e) {
  e.preventDefault();
  $('.user-info').removeClass('active');
  if ($(this).parent().hasClass('active')) {
    $(this).parent().removeClass('active');
  } else {
    $(this).parent().addClass('active');
  }
})

$('.user-info .link').bind('click', function (e) {
  e.preventDefault();
  $('.menu').removeClass('active');
  if ($(this).parent().hasClass('active')) {
    $(this).parent().removeClass('active');
  } else {
    $(this).parent().addClass('active');
  }
})
